import React from 'react'
import { Toaster } from '@8x8/oxygen-toaster'
import styled from 'styled-components'

const NotificationContainer = styled.div`
  position: absolute;
  width: 100%;
  z-index: 2;
`

function withNotificationsHoC (Component) {
  const withNotifications = props => (
    <>
      <NotificationContainer>
        <Toaster />
      </NotificationContainer>
      <Component {...props} />
    </>
  )

  return withNotifications
}

export default withNotificationsHoC
